import { alpha, Box, Divider, Grid, Typography } from "@mui/material";
import { JSX } from "react";
import { ImpactUpdated } from "~/components/impact/Updated/impact-updated";
import { ScoreRating } from "~/operations";
import { ScoreRatingColorMap } from "~/pages/reports/utils/reportsTypes";

interface PrintScoreBlockProps {
  mappings: { group: string; chart?: JSX.Element; value: number }[];
  ratingValues: { value: number; rating: ScoreRating };
}

export function ReportsPrintScoreBlock({
  mappings,
  ratingValues,
}: PrintScoreBlockProps) {
  const color = ScoreRatingColorMap[ratingValues.rating];

  return (
    <Box>
      <Grid
        container
        sx={{
          p: 5,
          backgroundColor: (theme) => alpha(theme.palette[color].main, 0.1),
          maxWidth: 320,
          width: 320,
          borderRadius: 1,
          border: "none",
        }}
      >
        <Grid size={12}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <ImpactUpdated
              showText={false}
              impact={{
                rating: ratingValues.rating,
                value: ratingValues.value,
              }}
              isRiskScore
              options={{ size: 16, border: 2 }}
            />
            <Typography
              sx={{
                fontSize: 24,
                fontWeight: 700,
                lineHeight: "24px",
                letterSpacing: ".96px",
                pt: 2,
              }}
            >
              {ratingValues.rating}
            </Typography>
          </Box>
          <Divider
            sx={{
              my: 3,
              borderBottomWidth: 2,
              borderColor: (theme) => alpha(theme.palette[color].main, 0.1),
            }}
          />
          {mappings.map((mapping) => (
            <Box
              key={mapping.group}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                mb: 2,
                "&:last-child": { mb: 0 },
              }}
            >
              <Typography
                sx={{
                  flexBasis: "55%",
                  fontWeight: 700,
                  lineHeight: "16px",
                }}
              >
                {mapping.group}
              </Typography>
              <Box
                sx={{
                  flexBasis: "50px",
                  textAlign: "right",
                }}
              >
                {mapping.chart}
              </Box>
              <Typography
                sx={{
                  fontWeight: 700,
                  lineHeight: "24px",
                  whiteSpace: "nowrap",
                  flexBasis: "40px",
                  textAlign: "right",
                }}
              >
                {mapping.value}
              </Typography>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
}
